import Action from '../Action';
import VehicleUtilService from '../../services/Util/VehicleUtilService';
import { message } from 'antd';

export function fetchVehicleUtils() {
	return (dispatch) => {
		VehicleUtilService.get()
			.then((utils) => dispatch({ type: Action.FETCH_VEHICLE_UTILS, utils: utils.data }))
			.catch((error) => message.error('Failed to fetch utils!'));
	};
}
